import { render, staticRenderFns } from "./CheckboxButton.vue?vue&type=template&id=8358c666&scoped=true&"
import script from "./CheckboxButton.vue?vue&type=script&lang=js&"
export * from "./CheckboxButton.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxButton.vue?vue&type=style&index=0&id=8358c666&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8358c666",
  null
  
)

export default component.exports